export default {
  errorNoLongerLive: {
    id: 'liveMoment.error.notLive',
    defaultMessage: 'This artist is no longer live.',
  },
};
